// Client-bearing copy rule: no jokes, no aphorisms, no presumption of
// guilt or re-offense on pages that name or summarize real clients.

function formatRefreshDate(d: Date): string {
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function FooterQuote(): JSX.Element {
  const refreshedAt = formatRefreshDate(new Date());
  return (
    <section
      className="no-print"
      aria-label="Record provenance"
      style={{
        marginTop: 48,
        marginBottom: 16,
        paddingInline: 24,
      }}
    >
      <div
        className="container"
        style={{
          maxWidth: 920,
          marginInline: "auto",
          textAlign: "center",
          color: "var(--color-text-dim)",
          fontFamily: "var(--font-mono)",
          fontSize: 12,
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          lineHeight: 1.7,
        }}
      >
        <div
          aria-hidden="true"
          style={{
            width: 32,
            height: 1,
            background: "var(--color-line-hi)",
            margin: "0 auto 18px",
          }}
        />
        Records pulled from NJ court and MVC systems. Last refreshed {refreshedAt}.
      </div>
    </section>
  );
}
